import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initErrorCollector, initRequestCollector } from './utils/technicalContext';
import { initConsoleGuard } from './utils/consoleGuard';
import { SubdomainManager } from './utils/subdomainUtils';

initConsoleGuard();
initErrorCollector();
initRequestCollector();

// Stale-build recovery: if the browser is holding an old index.html that references
// JS chunks the new deploy no longer serves, the load fails with ChunkLoadError.
// Reload once to pick up the fresh HTML; sessionStorage guard prevents a reload loop.
const CHUNK_RELOAD_KEY = 'chunk-reload-attempted';
const isChunkLoadError = (msg: string) =>
  /Loading chunk [\d]+ failed|ChunkLoadError|Failed to fetch dynamically imported module|Importing a module script failed/i.test(msg);

window.addEventListener('error', (e) => {
  const msg = `${e.message || ''} ${e.error?.message || ''}`;
  if (isChunkLoadError(msg) && !sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
    window.location.reload();
  }
});
window.addEventListener('unhandledrejection', (e) => {
  const msg = `${e.reason?.message || ''} ${String(e.reason || '')}`;
  if (isChunkLoadError(msg) && !sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
    window.location.reload();
  }
});
window.addEventListener('load', () => sessionStorage.removeItem(CHUNK_RELOAD_KEY));

async function bootstrap() {
  // If a transfer code is present in the URL, exchange it for real tokens
  // BEFORE React mounts. Without this, route-protection checks tokens
  // synchronously while the async exchange is still in-flight, sees nothing
  // in localStorage, and logs the user out immediately.
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('code') && !localStorage.getItem('access_token')) {
    await SubdomainManager.restoreTokensFromUrl();
  }

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  reportWebVitals();
}

bootstrap();
